import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { LeftMenuService } from 'app/store/services/left-menu.service';
import {
  DataSourceParams,
  EFilterSize,
  EFilterType,
  ITableColumn,
  ITableFilter,
  ITableFIlterGroup,
  ITableMassiveAction,
} from 'app/store/models/table.model';
import { IUserSessionData, UserType } from 'app/store/models/user.model';
import { SessionService } from 'app/store/services/session.service';
import { IReducers } from 'app/store/reducers';
import { ApiDataSource } from 'app/datasources/api.datasrouce';
import {
  EMessageItemStatus,
  IMessageItem,
  IMessageLockDataResponse,
  IMessageWSTopicData,
  MESSAGE_WS_ACTION_LOCK,
  MESSAGE_WS_ACTION_UNLOCK,
  MESSAGES_WS_TOPIC,
} from 'app/store/models/message.model';
import { clearMessages, loadMessages, loadMessagesSuccess } from 'app/store/actions/message.action';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ContactsService } from 'app/store/services/contacts.service';
import { updateLeftMenuCount } from 'app/store/actions/meeting.action';
import { MessageService } from '../../store/services/message.service';
import { WebSocketService } from '../../store/services/web-socket.service';
import { openSnackbar } from '../../store/actions/page.action';
import { TableComponent } from '../../shared/ui/table/table.component';
import { faClone, faEnvelope, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-list-messages',
  templateUrl: './list-messages.component.html',
  styleUrls: ['./list-messages.component.scss'],
})
export class ListMessagesComponent implements OnInit, OnDestroy {
  @ViewChild('tableComponent') tableComponent: TableComponent;
  tableColumns: ITableColumn<IMessageItem>[] = null;
  tableDataSource: ApiDataSource<IMessageItem>;
  tableDataSourceParams: DataSourceParams = {
    sortDir: 'desc',
    page: 1,
    pageSize: 10,
    sortAttr: 'message_date',
    filters: {},
  };
  tableFilterGroups: ITableFIlterGroup[] = [
    {
      filters: [
        {
          type: EFilterType.SEARCH,
          label: 'Search',
          items: [
            {
              id: 'search',
              label: 'Search...',
            },
          ],
        },
      ],
    },
  ];
  tableFilters: ITableFilter[] = [
    {
      type: EFilterType.SELECT,
      size: EFilterSize.HALF,
      label: 'Filter by',
      id: 'filter',
      items: [
        {
          label: 'All',
          value: 'reset',
          id: 'filter',
        },
        {
          label: 'Unmatched',
          value: 'unmatched',
          id: 'filter',
        },
        {
          label: 'Unread',
          value: 'unread',
          id: 'filter',
        },
      ],
    },
  ];
  sessionData: IUserSessionData;
  tableMassiveActions: ITableMassiveAction<IMessageItem>[] = [
    {
      label: 'Keep Current Status',
      handler: (rows: IMessageItem[]) => {
        const data = rows.map((item: any) => {
          return item.contact_id;
        });

        this.contactsService
          .quickResponse({ contacts: data }, 'okgotit-multiple')
          .subscribe(response => {
            this.store.dispatch(updateLeftMenuCount({ data: {} }));
            this.tableDataSource = new ApiDataSource(
              this.http,
              environment.apiUrl + '/v1/messages',
              {
                extra: {
                  include: this.sessionData.emails_preview,
                  column: 'content',
                },
              },
            );
            console.log(response);
          });
      },
    },
  ];
  useTableRouteNavigation: boolean;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private sessionService: SessionService,
    private store: Store<IReducers>,
    private http: HttpClient,
    private lefMenuService: LeftMenuService,
    private router: Router,
    private contactsService: ContactsService,
    private readonly wsService: WebSocketService,
    private readonly messagesService: MessageService,
  ) {
    this.store.dispatch(loadMessages());
  }

  getRowClass = (row: IMessageItem) => {
    const res = ['route_message'];
    // if (row.new_response) {
    //   res.push('new_response');
    // }

    if (!row.read_status) {
      res.push('bolded_row');
    }

    if (row.message_status === EMessageItemStatus.ALERT_SUCCERSS) {
      res.push('alert-success');
    }

    let messageEscalated: boolean;

    if (row.message_status?.indexOf('vsm_escalated') !== -1) {
      messageEscalated = true;
      res.push('message-purple');
    }

    if (row.message_status?.indexOf('unmatched_msg') !== -1 && !messageEscalated) {
      res.push('message-red');
    }

    if (row.message_status?.indexOf('universal_contact') !== -1) {
      res.push('italic-row');
    }

    return res;
  };

  viewMessage(messageElement: IMessageItem) {
    const params: { from: string, manager_id?: number } = {
      from: 'inbox',
    };

    if (this.sessionData && this.sessionData.user_type === UserType.VSM && messageElement.manager_id) {
      params.manager_id = messageElement.manager_id;
    }

    this.router.navigate([
      `/messages/view`,
      messageElement.message_id,
      params,
    ]);
  }

  ngOnDestroy() {
    this.store.dispatch(clearMessages());
    this.destroy$.next(false);
  }

  ngOnInit() {
    this.lefMenuService.expand('inbox');
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe((session: IUserSessionData) => {
        this.sessionData = session;
        if (!this.canProcessMessages()) {
          this.tableMassiveActions = [];
        }
        if (
          this.sessionData.user_type === UserType.VSM ||
          this.sessionData.user_type === UserType.MASTER
        ) {
          if (this.sessionData.user_type === UserType.VSM) {
            this.tableFilters[0].items = this.tableFilters[0].items.filter(item => item.value !== 'unread');
            this.useTableRouteNavigation = true;
          } 

          this.tableFilters[0].items.push({
            label: 'Locked',
            value: 'locked',
            id: 'filter',
         }); 

          if (this.sessionData.user_type === UserType.MASTER) {
            this.tableMassiveActions.push({
              label: 'Unlock',
              handler: (rows: IMessageItem[]) => {
                rows.forEach(message => {
                  if (!this.wsService.connected) {
                    this.messagesService
                      .viewMessage(message.message_id, undefined, true)
                      .subscribe();
                  } else {
                    this.wsService.send<IMessageWSTopicData>({
                      topic: MESSAGES_WS_TOPIC,
                      data: {
                        action: MESSAGE_WS_ACTION_UNLOCK,
                        message_id: message.message_id,
                      },
                    });
                  }
                });
              },
            });
          }
          this.initSocket();
        }

        const tableColumns: ITableColumn<IMessageItem>[] = [
          {
            id: 'vsm_group',
            title: 'Edge Group name',
            disabled: this.sessionData.user_type !== UserType.VSM,
          },
          {
            id: 'contact_firstname',
            title: 'Contact',
            leftAdjusted: true,
            asHtml: true,
            getFaIconPrefix: (element: IMessageItem) => {
              if (element.duplicate_contact) {
                return faClone;
              }
              if (element.is_spam) {
                return faTriangleExclamation;
              }
              if (!element.read_status) {
                return faEnvelope;
              }

              return null
            },
            renderer: row => {
              if (!row.contact_firstname && !row.contact_lastname) {
                return row.contact_email;
              }
              return `${row.contact_firstname || ''} ${
                row.contact_lastname || ''
              }`;
            },
            route: (element: IMessageItem) =>
              this.viewMessage(element),
          },
          {
            id: 'company',
            title: 'Company',
            leftAdjusted: true,
            sortable: true,
            route: (element: IMessageItem) =>
              this.viewMessage(element),
          },
          {
            id: 'subject',
            title: 'Subject',
            leftAdjusted: true,
            sortable: true,
            route: (element: IMessageItem) =>
              this.viewMessage(element),
          },
          {
            id: 'message_date',
            title: 'Date',
            sortable: true,
            route: (element: IMessageItem) =>
              this.viewMessage(element),
            isDateColumn: true,
            dateFormat: 'MM/DD/YYYY',
          },
        ];

        if (session.user_type !== UserType.SINGLE_USER) {
          tableColumns.push({
            id: 'representative_firstname',
            title: 'Account',
            renderer: row => {
              return `${row.representative_firstname} ${row.representative_lastname}`;
            },
            route: (element: IMessageItem) =>
              this.viewMessage(element),
          });
        }

        if (session.emails_preview) {
          tableColumns.push({
            id: 'content',
            title: 'Message',
            leftAdjusted: true,
            asHtml: true,
            renderer: item => {
              if (!item.content) {
                return '';
              }
              return item.content.slice(0, 500) + '...';
            },
            route: (element: IMessageItem) =>
              this.viewMessage(element),
          });
        }

        if (
          this.sessionData.user_type === UserType.VSM ||
          this.sessionData.user_type === UserType.MASTER
        ) {
          tableColumns.push({
            id: 'locked_by_name',
            title: 'Locked By',
          });
        }

        this.tableColumns = tableColumns;
        if (session === undefined) {
          return;
        }

        this.tableDataSource = new ApiDataSource(
          this.http,
          environment.apiUrl +
          '/v1/messages' +
          (this.sessionData.user_type === UserType.VSM ? '/vsm' : ''),
        );
      });
  }

  onData = (items: IMessageItem[]) => {
    this.store.dispatch(
      loadMessagesSuccess({
        messages: items,
        has_extra_row: this.sessionData.emails_preview,
      }),
    );
  };

  customFilterSelection($event: string) {
    if (!$event) {
      return;
    }

    if (!this.tableDataSourceParams.filters) {
      this.tableDataSourceParams.filters = {};
    }

    if ($event === 'reset') {
      this.tableDataSourceParams.filters.filter = null;
    } else {
      this.tableDataSourceParams.filters.filter = $event;
    }

    this.tableComponent.refresh();
  }

  private showProcessesMessageSnackbar() {
    this.store.dispatch(openSnackbar({
      snackbarData: {
        data: {
          message: 'The inbox state has changed. Please refresh',
          type: 'success',
          button: {
            text: 'Refresh',
            onClick: (snackbarComponent) => {
              this.tableComponent.refresh();
            },
          },
        },
      },
    }));
  }

  private initSocket() {
    this.wsService
      .on<IMessageLockDataResponse>(MESSAGES_WS_TOPIC)
      .subscribe(data => {
        // if (data && data.action === 'processed') {
        //   if ((!this.sessionData || this.sessionData.user_type !== UserType.VSM) || this.sessionData.id === data.account_id) {
        //     return;
        //   }
        //   this.showProcessesMessageSnackbar();
        //   return;
        // }
        const tableData = [
          ...this.tableDataSource.getData<IMessageItem>().map(message => {
            if (message.message_id === data.message_id) {
              message.locked_by_name =
                data.action === MESSAGE_WS_ACTION_LOCK
                  ? data.account_name
                  : null;
            }

            return message;
          }),
        ];

        console.log('here 2', tableData);

        this.tableDataSource.internalRefresh(tableData);
      });
  }

  private canProcessMessages(): boolean {
    return !!(
      this.sessionData &&
      this.sessionData.user_type !== UserType.PARTNER &&
      this.sessionData.user_type !== UserType.FRANCHISE
    );
  }
}
